<lib-notification-view [viewFrom]="'step'" [inputData]="currentItem"></lib-notification-view>